import { z } from 'zod'
import { oc } from '@orpc/contract'
import { REFERRAL_SPECIALTY_CODES } from '../referral-specialties.schema'
import { resolvedRecipientSchema } from './referral-discovery-views.schema'

// A named doctor (npi), a practice with no doctor chosen (placeId), or a doctor at a
// chosen practice (both). The server re-reads NPPES and Google itself — it never trusts
// names or addresses sent by the client.
export const referralDiscoveryResolveInputSchema = z
  .object({
    specialtyCode: z.enum(REFERRAL_SPECIALTY_CODES),
    npi: z
      .string()
      .regex(/^\d{10}$/)
      .optional(),
    // URL-safe like every Google place id; it reaches a FHIR identifier search.
    placeId: z
      .string()
      .regex(/^[A-Za-z0-9_-]{1,300}$/)
      .optional(),
  })
  .refine((v) => Boolean(v.npi || v.placeId), { message: 'npi or placeId is required' })

export const referralDiscoveryResolve = oc
  .route({ method: 'POST', path: '/v2/referral-discovery/resolve' })
  .input(referralDiscoveryResolveInputSchema)
  .output(resolvedRecipientSchema)
